<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Swal from "sweetalert2";

import axios from "axios";
import { required } from "vuelidate/lib/validators";
import { requiredIf } from "vuelidate/lib/validators";

/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Years List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  data() {
    return {
      gridData: {
        data: [],
        total: 0,
      },
      title: "Years List",
      model: "Year",
      items: [
        {
          text: "Dashboard",
          href: "/dashboard"
        },
        {
          text: 'Years List',
          active: true
        }
      ],
      submitted: false,
      theads: ["No.", "Name", "Status", "Action"],
      isLoadingGetList: false,
      isLoadingPost: false,
      filter: {
        paginate_count: 10,
        page: 1,
      },
      selected_data: {
        name: null,
        is_active: 0
      },
      token: null,
      modal_type: 'create',
      error_messages: [],
      list_error_messages: []
    };
  },
  validations: {
    selected_data: {
      name: { required }
    },
  },
  async mounted(){
    
    this.token = await localStorage.getItem('authToken')

    this.getList();
  },
  watch: {
    'filter.page': function(){
      this.getList();
    }
  },
  methods: {
    renderModalTitle(){
      return (this.selected_data.id ? 'Edit Data' : 'Create New') + ' ' + this.model;
    },
    formSubmit(e) {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      this.isLoadingPost = true;

      let url = process.env.VUE_APP_API + '/year'
      let data = this.selected_data;
      let success_message = 'Successfully create new ' + this.model;

      if(this.modal_type == 'edit'){
        url = url + '/' + this.selected_data.id;
        data._method = 'PUT';
        success_message = 'Successfully update ' + this.model;
      }

      axios.post(url, data, {
        headers: {
          Authorization: 'Bearer ' + this.token 
        }
      })
      .then((res) => {
        Swal.fire("Success!", success_message, "success");
        this.$bvModal.hide('modal-data');
        this.getList();
      })
      .catch((err) => {
        if('response' in err){
          if('data' in err.response){
            if('message' in err.response.data){
              this.error_messages = err.response.data.data;
            }
          }
        }
        this.err = err;
      })
      .finally(() => {
        this.isLoadingPost = false;
        this.submitted = false;
      });
    },
    onDelete(data){
      Swal.fire({
        title: "Delete "+ this.model +" (" + data.name + ")?",
        text: "Disactivate selected "+ this.model +". You can restore it later!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          axios.post(process.env.VUE_APP_API + '/year/' + data.id, {
            _method: 'DELETE'
          }, {
            headers: {
              Authorization: 'Bearer ' + this.token
            }
          })
          .then(res => {
            Swal.fire("Deleted!", data.name + ' has been removed', "success");
            this.getList();
          })
          .catch(err => {
            if('response' in err){
              if('data' in err.response){
                if('message' in err.response.data){
                  this.list_error_messages = err.response.data.data;
                }
              }
            }
          })
        }
      });
    },
    onRestore(data){
      Swal.fire({
        title: "Restore "+ this.model +" (" + data.name + ")?",
        text: "You are going to restore selected "+ this.model,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, restore data!"
      }).then(result => {
        if (result.value) {
          axios.post(process.env.VUE_APP_API + '/year/' + data.id + '/restore', {
            _method: 'PUT'
          }, {
            headers: {
              Authorization: 'Bearer ' + this.token
            }
          })
          .then(res => {
            Swal.fire("Restored!", data.name + " has been restored", "success");
            this.getList();
          })
        }
      });
    },
    getList(){
      this.isLoadingGetList = true;

      //fetch data from API
      axios.get(process.env.VUE_APP_API + '/year?page=' + this.filter.page + '&paginate_count=' + this.filter.paginate_count, {
        headers: {
          'Authorization': 'Bearer ' + this.token
        }
      })
      .then(res => {
        this.gridData = res.data.data;
        this.list_error_messages = [];
      })
      .catch(err => {
        this.err = err;
      })
      .finally(() => {
        this.isLoadingGetList = false;
      });
    },
    onClickCreate(e){
      e.target.blur();
      
      this.error_messages = [];
      this.modal_type = 'create';
      this.submitted = false;
      this.selected_data = {
        name: null,
        is_active: 0
      };

      this.$bvModal.show('modal-data');
    },
    onEdit(year){
      this.error_messages = [];
      this.modal_type = 'edit';
      this.submitted = false;
      this.selected_data = JSON.parse(JSON.stringify(year));
      this.$bvModal.show('modal-data');
    },
    onReport(year){
      this.$router.push({ name: 'Show Year Report', params: {
        id: year.id,
      }, query: {
        name: year.name
      }})
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="col">
              <b-alert show variant="danger" v-for="(err, index) in list_error_messages" :key="`list_error_${index}`">
                {{ err }}
              </b-alert>
            </div>
            <div class="right">
              <b-button @click="e => onClickCreate(e)" variant="primary">Create New {{ this.model }}</b-button>
            </div>
            <div class="table-responsive mt-2">
              <table class="table align-middle table-nowrap table-hover">
                <thead class="table-light">
                  <tr>
                    <th scope="col" v-for="(thead, index) in theads" :key="`head_${index}`">{{thead}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="gridData.data.length < 1 && !isLoadingGetList">
                    <td :colspan="theads.length" class="text-center"><i>--- No data available ---</i></td>
                  </tr>
                  <tr v-for="n in 3" :key="`loading_tr_${n}`" v-if="isLoadingGetList">
                    <td class="placeholder-glow" v-for="i in theads.length" :key="`placeholder_${i}`"><span class="placeholder col-12 placeholder-lg"></span></td>
                  </tr>
                  <tr v-for="(list, index) in gridData.data" :key="list.id" v-if="!isLoadingGetList">
                    <td width="5%">
                      <span :class="list.is_deleted ? 'text-danger' : 'text-dark'">{{ index + 1 }}.</span>
                    </td>
                    <td>
                      <h5 class="font-size-14 mb-1">
                        <span :class="list.is_deleted ? 'text-danger' : 'text-dark'">{{list.name}}</span>
                      </h5>
                    </td>
                    <td>
                      <h5 class="font-size-14 mb-1">
                        <span :class="list.is_deleted ? 'text-danger' : 'text-muted'">{{list.is_active ? 'Active' : 'Disabled'}}</span>
                      </h5>
                    </td>
                    <td>
                      <ul class="list-inline font-size-20 contact-links mb-0">
                        <li class="list-inline-item px-2 cursor-pointer" @click="onReport(list)">
                          <a v-b-tooltip.hover title="Edit" class="font-size-14">
                            <i class="bx bxs-report text-success"></i> Report
                          </a>
                        </li>
                        <li class="list-inline-item px-2 cursor-pointer" @click="onEdit(list)" v-if="!list.is_deleted">
                          <a v-b-tooltip.hover title="Edit" class="font-size-14">
                            <i class="bx bx-edit text-primary"></i> Edit
                          </a>
                        </li>
                        <li class="list-inline-item px-2 cursor-pointer" @click="onDelete(list)" v-if="!list.is_deleted">
                          <a v-b-tooltip.hover title="Delete" class="font-size-14">
                            <i class="bx bx-trash-alt text-danger"></i> Delete
                          </a>
                        </li>
                        <li class="list-inline-item px-2 cursor-pointer" @click="onRestore(list)" v-if="list.is_deleted">
                          <a v-b-tooltip.hover title="Restore" class="font-size-14">
                            <i class="mdi mdi-delete-restore text-success"></i> Restore
                          </a>
                        </li>
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row mt-3" v-if="gridData.data.length">
              <div class="col-lg-12">
                <b-pagination
                  v-model="filter.page"
                  :total-rows="gridData.total"
                  :per-page="filter.paginate_count"
                  aria-controls="my-table"
                  align="center"
                ></b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="modal-data" :title="renderModalTitle()" title-class="font-18" hide-footer>
      <form class="needs-validation" @submit.prevent="formSubmit">
        <div class="row">
          <div class="col">
            <b-alert show variant="danger" v-for="(err, index) in error_messages" :key="`error_${index}`">
              {{ err }}
            </b-alert>
          </div>
          <div class="col-md-12">
            <div class="mb-3">
              <label for="inputField3">Name <span class="text-danger small">*</span></label>
              <input
                id="inputField3"
                v-model="selected_data.name"
                type="text"
                class="form-control"
                placeholder="Enter name"
                :class="{
                  'is-invalid': submitted && $v.selected_data.name.$error,
                }"
              />
              <div v-if="submitted && $v.selected_data.name.$error" class="invalid-feedback">
                <span v-if="!$v.selected_data.name.required">Name is required.</span>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="mb-3">
              <b-form-checkbox v-model="selected_data.is_active" value="1" unchecked-value="0" class="mt-1">
                <span class="ps-2">Set to Active</span>
              </b-form-checkbox>
              <span class="small text-muted">By ticking this option, you are about to set this data to active and disable current {{ model }}</span>
            </div>
          </div>
        </div>
        <div class="col-12 right">
          <button :disabled="isLoadingPost" class="btn btn-primary me-2" type="submit">Submit</button>
          <!-- <button :disabled="isLoadingPost" class="btn btn-light" @click="$bvModal.hide('modal-data')">Close</button> -->
        </div>
      </form>
    </b-modal>
  </Layout>
</template>